import { MAX_REVIEWS } from "../../../../lib/constants";
import { Grid } from "@mui/material";
import {
  ListingReviewCard,
  ListingReviewCardProvider,
} from "./listingReviewCard";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { useListingReviewsSectionContext } from "./ListingReviewsSectionProvider";

export const ListingReviewsGridContent = () => {
  const reviewsRedux = useSelector(
    (state: RootState) => state.trainingPlan.reviews,
  );
  const { state } = useListingReviewsSectionContext();

  return (
    <>
      {reviewsRedux.map((review, index) => {
        if (index > MAX_REVIEWS && !state.showAllReviews) {
          return;
        } else if (index <= MAX_REVIEWS || state.showAllReviews) {
          return (
            <Grid key={index} item xs={12} lg={6}>
              <ListingReviewCardProvider review={review}>
                <ListingReviewCard />
              </ListingReviewCardProvider>
            </Grid>
          );
        }
      })}
    </>
  );
};
